import { render, staticRenderFns } from "./select-group-redir.vue?vue&type=template&id=bd30095a"
import script from "./select-group-redir.vue?vue&type=script&lang=js"
export * from "./select-group-redir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports